import { Country } from '@superbet-group/web.types';
import { WelcomeBonus } from '@core/models/bonus/WelcomeBonus';

import {
    BetlerWelcomeBonusDto,
    ComtradeWelcomeBonusDto,
} from './dtos/WelcomeBonusDto';
import { transformBetlerWelcomeBonus } from './transformBetlerWelcomeBonus';
import { transformComtradeWelcomeBonus } from './transformComtradeWelcomeBonus';

export const transformWelcomeBonus: Record<Country, (bonus: any) => WelcomeBonus> = {
    [Country.Ro]: (bonus: ComtradeWelcomeBonusDto) => transformComtradeWelcomeBonus(bonus),
    [Country.RoNapoleon]: (bonus: BetlerWelcomeBonusDto) => transformBetlerWelcomeBonus(bonus),
    [Country.Pl]: (bonus: ComtradeWelcomeBonusDto) => transformComtradeWelcomeBonus(bonus),
    [Country.Com]: (bonus: BetlerWelcomeBonusDto) => transformBetlerWelcomeBonus(bonus),
    [Country.Br]: (bonus: BetlerWelcomeBonusDto) => transformBetlerWelcomeBonus(bonus),
    [Country.BrSocial]: (bonus: BetlerWelcomeBonusDto) => transformBetlerWelcomeBonus(bonus),
    [Country.Rs]: (bonus: BetlerWelcomeBonusDto) => transformBetlerWelcomeBonus(bonus),
    [Country.Be]: (bonus: BetlerWelcomeBonusDto) => transformBetlerWelcomeBonus(bonus),
    [Country.Bg]: (bonus: BetlerWelcomeBonusDto) => transformBetlerWelcomeBonus(bonus),
};
